































import { Vue } from "vue-property-decorator";
import type { manage_log } from "@/@types/invest/log"
import LogInfo from "@/views/invest_log/info.vue"

export default Vue.extend({
  name      : "ManageLogs",
  components: { LogInfo },
  props     : {
    id: { type: String, default: "" },
  },
  data() {
    return {
      all  : [] as manage_log[],
      data : [] as manage_log[],
      icons: {}
    }
  },
  methods: {
    init() {
      this.get_logs()
    },
    async get_logs() {
      const params = { estimate_id: this.id }
      const res    = await this.$store.dispatch("invest_log/list", params);
      if (res.Code == 200) {
        const data = res.Data
        for (const k in data) {
          if (data[k]) {
            if (!data[k].data) data[k].data = []
            const temp = this.$deep_copy(data[k])
            if (temp.data.length > 3) {
              temp.data = []
              for (let i = 0; i < 3; i += 1) {
                if (data[k].data[i]) temp.data.push(data[k].data[i])
              }
            }
            this.data.push(temp)
          }
        }
        this.all = data
      }
    },
    load_more(key: number) {
      console.log("Load Moew")
      const all   = this.$deep_copy(this.all)
      const start = this.data[key].data.length
      for (let i = 0; i < 3; i += 1) {
        if (all[key].data[start + i]) {
          this.data[key].data.push(all[key].data[start + i])
        }
      }
    },
    info(id: number, t?: string) {
      this.$nextTick(() => {
        const log_info = this.$refs.log_info as any
        log_info.open(id, `${t}详情`)
      })
    }
  },
  watch: {
    id(id: string) {
      if (id != "0") {
        this.$nextTick(() => {
          this.init();
        })
      }
    }
  }
})

